import React, { useState, useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box, Stack, Text } from "@thecb/components";
import ActivityHistory from "../activity-history/ActivityHistory";
import TransactionHistory from "../profile-transaction-history/TransactionHistory";
import { CHARADE_GREY, STORM_GREY } from "../../../../../../constants/colors";

const ProfileHistory = ({ ...props }) => {
  const [activeTab, setActiveTab] = useState("transaction-history");
  const [
    shouldRefreshActivityHistory,
    setShouldRefreshActivityHistory
  ] = useState(false);
  const themeContext = useContext(ThemeContext);
  const { isMobile } = themeContext;

  const tabs = [
    {
      id: "transaction-history",
      label: "Transaction History",
      title: "Transaction History"
    },
    {
      id: "activity-history",
      label: "Activity History",
      title: "Activity History"
    }
  ];

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  const handleTabClick = tabId => {
    setActiveTab(tabId);
    if (tabId === "activity-history") {
      setShouldRefreshActivityHistory(prev => !prev);
    }
  };

  const getActiveTabStyles = tabId => {
    const isActive = activeTab === tabId;
    return `
      color: ${isActive ? CHARADE_GREY : STORM_GREY};
      font-weight: ${isActive ? "600" : "400"};
    `;
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "activity-history":
        return (
          <ActivityHistory
            {...props}
            shouldRefresh={shouldRefreshActivityHistory}
          />
        );
      case "transaction-history":
        return <TransactionHistory {...props} />;
      default:
        return <TransactionHistory {...props} />;
    }
  };

  return (
    <Box role="main">
      <Stack childGap="0">
        {/* Visually hidden heading for accessibility */}
        <Box padding="0" srOnly="true">
          <Text as="h1">{activeTabData?.title || "Profile History"}</Text>
        </Box>

        {/* Tab Navigation */}
        <Box role="tablist" padding="0">
          <Stack
            direction="horizontal"
            childGap="0"
            extraStyles={`padding: 0 0 1rem`}
          >
            {tabs.map((tab, index) => (
              <Box
                key={tab.id}
                role="tab"
                padding="0"
                tabIndex={0}
                aria-selected={activeTab === tab.id}
                aria-controls={`tabpanel-${tab.id}`}
                id={`tab-${tab.id}`}
                onClick={() => handleTabClick(tab.id)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleTabClick(tab.id);
                  }
                }}
                extraStyles={`
                    ${getActiveTabStyles(tab.id)}
                    font-size: ${isMobile ? "1.125rem" : "1.25rem"};
                    line-height: 1.875rem;
                    word-wrap: break-word;
                    cursor: pointer;
                    margin: ${isMobile ? "0.5rem" : "0.5rem 1rem"};
                    padding: 0;
                    transition: all 0.2s ease;
                    text-align: center;
                    ${index == 0 ? "margin-left: 0;" : ""}
                `}
              >
                {tab.label}
              </Box>
            ))}
          </Stack>
        </Box>

        {/* Tab Content */}
        <Box
          role="tabpanel"
          padding="0"
          id={`tabpanel-${activeTab}`}
          aria-labelledby={`tab-${activeTab}`}
        >
          {renderTabContent()}
        </Box>
      </Stack>
    </Box>
  );
};

export default ProfileHistory;
